const validate = (value = "", validators) => {
  return validators.reduce(
    (acc, validator) => (acc === undefined ? validator(value) : acc),
    undefined
  );
};

const validateField = (target, value, validators) => {
  const error = validate(value, validators);
  if (error !== undefined) {
    return error;
  }
};

const validateArray = (target, array, validators) => {
  const arrayError =
    validators.array !== undefined
      ? validate(array, validators.array)
      : undefined;

  const elementsError =
    validators.element !== undefined
      ? array.reduce((acc, object, index) => {
          const error = validateObject(object, validators.element);
          if (error !== undefined) {
            return { ...acc, [index]: error };
          }
          return acc;
        }, undefined)
      : undefined;
  if (arrayError !== undefined || elementsError !== undefined) {
    return {
      array: arrayError,
      elements: elementsError
    };
  }
};

export const validateObject = (object, validators) =>
  Object.keys(object).reduce((acc, key) => {
    const validator = validators[key];
    if (validator !== undefined) {
      const currentField = object[key];
      const error = Array.isArray(currentField)
        ? validateArray(key, currentField, validator)
        : typeof currentField === "object"
        ? validateObject(currentField, validator)
        : validateField(key, currentField, validator);
      return error !== undefined
        ? {
            ...acc,
            [key]: typeof currentField === "object" ? { ...error } : error
          }
        : acc;
    }
    return acc;
  }, undefined);

export const mandatory = value => {
  if (value === undefined || value.length === 0) {
    return "errorMandatory";
  }
};

export const mandatoryRTE = value => {
  if (
    value === undefined ||
    value.replace(/(<([^>]+)>)/gi, "").replace(/\s/g, "").length === 0
  ) {
    return "errorMandatory";
  }
};

export const max = length => value => {
  if (value && value.length > length) {
    return "errorMax";
  }
};

export const number = value => {
  if (value === "" || isNaN(value)) {
    return "errorNumber";
  }
};
export const numberMin = min => value => {
  if (value && value < min) {
    return { key: "errorNumberMin", params: [min] };
  }
};
export const numberMax = max => value => {
  if (value && value > max) {
    return { key: "errorNumberMax", params: [max] };
  }
};
export const numberBetween = (min, max) => value => {
  if (value && (value < min || value > max)) {
    return { key: "errorNumberBetween", params: [min, max] };
  }
};

const mailCheck = /^[a-zA-Z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,4}$/;
export const email = value => {
  if (value !== undefined && value !== "" && mailCheck.exec(value) === null) {
    return "errorMail";
  }
};

const phoneCheck = /^\+?[0-9,(,),.,\-, ]{6,19}[0-9]$/;
export const phone = value => {
  if (value !== undefined && value !== "" && phoneCheck.exec(value) === null) {
    return "errorPhone";
  }
};

const digitCheck = /^[0-9]*$/;
export const digit = value => {
  if (digitCheck.exec(value) === null) {
    return "errorDigit";
  }
};

const decimalCheck = /^[0-9]+\.*[0-9]*$/;
export const decimal = value => {
  if (decimalCheck.exec(value) === null) {
    return "errorDecimal";
  }
};

const dateCheck = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
export const date = value => {
  if (dateCheck.exec(value) === null) {
    return "errorDate";
  }
};



// WEBPACK FOOTER //
// ./src/services/validator.js